module.exports = __webpack_public_path__ + "img/IcBaselineShortcut.cb9577e0.png";